import React from 'react';
import {Button, ConfigProvider} from "antd";
import {ButtonProps} from "antd/lib/button/button";

export default function ButtonRed({ ...props }: ButtonProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#C11801',
        },
      }}
    >
      <Button type={"primary"} {...props}>
        {props.children}
      </Button>
    </ConfigProvider>
  )
}
